var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',_vm._b({on:{"success":function($event){_vm.$emit('success',$event)}}},'Page',_vm.page,false))}
var staticRenderFns = []

export { render, staticRenderFns }